/**
 * 加密配置
 * 配置 @iap/kit-encryptor 的全局加密参数
 */

// 注意：仅在包安装成功后才能使用
// import { encryptConfigure } from '@iap/kit-encryptor';
import LogUtil from "@/betby/utils/LogUtil";

/**
 * 从环境变量或配置中心获取加密密钥
 * 生产环境应该从安全的配置中心获取，不要硬编码在代码中
 */
const getEncryptKeys = () => {
  return {
    // 是否启用加密
    isEncrypted: true,

    // 签名密钥（用于生成请求签名，防篡改）
    // TODO: 生产环境请替换为后端提供的真实密钥
    SIGN_KEY: process.env.NEXT_PUBLIC_SIGN_KEY || "L9gh=p%Eozfn2#@",

    // 数据加密密钥（用于 localStorage 等本地存储加密）
    // TODO: 生产环境请替换为后端提供的真实密钥
    DATA_KEY: process.env.NEXT_PUBLIC_DATA_KEY || "48ef8b4810e9260625c",

    // RSA 公钥（PEM 格式，用于请求加密）
    // TODO: 生产环境请替换为后端提供的真实公钥
    RSA_KEY:
      process.env.NEXT_PUBLIC_RSA_KEY ||
      "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDvuF8W2ghFIJ8xj/kpXQMAh04PNrLJP9UxFigM7MROvct7MIsn4PKvqF0uOrgIMS15mvONp6JghCkDOg4TKyc/SXtz9C4E/jDHoMy6e/w24WqvvL1T8mk+EftBL2ATjQ4UtW8vQeiyuAGOqfpr7m/tzfRIEoCZq21O8LyryslhywIDAQAB",

    // AES Web 版本专用密钥（16 字符，用于 AES 加密）
    // TODO: 生产环境请替换为后端提供的真实密钥
    AES_KEY_WEB: process.env.NEXT_PUBLIC_AES_KEY_WEB || "VIX5XN2539vQ4SQI",

    // AES Web 版本专用初始化向量（16 字符）
    // TODO: 生产环境请替换为后端提供的真实 IV
    AES_IV_WEB: process.env.NEXT_PUBLIC_AES_IV_WEB || "MM1B4I6w23QhzHhG",
  };
};

/**
 * 初始化加密配置
 * 在应用启动时调用此函数
 */
export function initEncryptConfig() {
  // 注意：取消下面的注释以启用自定义加密配置
  /*
  const config = getEncryptKeys();
  encryptConfigure(config);
  */

  // 仅在开发环境或日志开启时输出
  if (typeof window !== "undefined") {
    LogUtil.info(
      "[Encrypt Config] 使用默认加密配置（等待 @iap/kit-encryptor 包安装完成）",
    );
  }
}

/**
 * 导出密钥获取函数（用于测试或调试）
 */
export { getEncryptKeys };
